// @flow
import _ from 'lodash'
import React, { useState } from 'react'
import styled, { type StyledComponent } from 'styled-components'
import formatsImg from './formats.png'
import CheckMark from '../controls/CheckMark'

export type PlacementType = 'multi_format' | 'column' | 'with_video' | 'promo_post' | 'carousel'

function backgroundShift(format: PlacementType) {
  if (format === 'with_video') return -146 * 3
  if (format === 'column') return -146
  if (format === 'multi_format') return 0
  if (format === 'carousel') return -146 * 4
  return -146 * 2
}

const Card = styled.div`
  display: inline-block;
  width: 200px;
  height: 146px;
  margin: 0 32px;
  background-image: url(${formatsImg});
  background-position-y: ${({ format }: Object) => backgroundShift(format).toString()}px;
  ${({ isActive }) =>
    isActive
      ? `
    border-color: #3699c2;
    background-position-x: -200px;
    `
      : ''}
`
const ItemText = styled.div`
  padding: 5px 10px;
`
const ItemTitle = styled.div`
  text-align: center;
  font-size: 16px;
  width: 100%;
  padding-bottom: 15px;
`
const ItemNote = styled.div`
  font-size: 13px;
  color: gray;
  text-align: center;
`
const Wrapper: StyledComponent<Object, any, any> = styled.div`
  display: flex;
  ${({ multiline }) => (multiline ? 'flex-wrap: wrap' : '')};
  width: 900px;
`
const Item = styled.div`
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 16px 0;
  position: relative;
  cursor: pointer;
  width: 264px;
  height: 280px;
  margin-right: 5px;
  margin-bottom: 5px;

  &:hover {
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  }
`
const CheckMarkWrapper = styled.div`
  position: absolute;
  top: 5px;
  left: 5px;
`

const t = {
  multi_format_note:
    'Ваши объявления будут показаны повсюду: Промопосты в ленте, Тизеры в колонке в соц.сетях, Баннеры и адаптивный формат на сайтах',
  column_note: 'Классический формат тексто-графических объявлений',
  promo_post_note:
    'Нативные форматы социальных сетей гармонично вписываются в ленту и показывают повышенную эффективность',
  with_video_note: 'Используйте видео вместо картинки в ваших промопостах',
  column: 'В колонке',
  multi_format: 'Мультиформат',
  promo_post: 'Пост в ленте',
  with_video: 'Видеореклама',
  carousel: 'Карусель',
  carousel_note: 'Предоставьте потенциальному клиенту выбор с помощью карточек'
}

export type Props = {|
  onChange: (Array<PlacementType>) => void,
  options: Array<PlacementType>,
  value: Array<PlacementType>,
  multi: boolean
|}

export default function PlacementTypeSelect(props: Props) {
  const [hoverCard, setHoverCard] = useState(null)
  const options = props.options
  const multi = props.multi
  const value = multi ? props.value : leaveFirstOption(options, props.value)

  return (
    <Wrapper multiline={options.length > 4} className="t-PlacementType">
      {_.map(options, (key) => {
        const isActive = _.includes(value, key)
        const isHover = key === hoverCard
        return (
          <Item
            key={key}
            onMouseEnter={() => setHoverCard(key)}
            onMouseLeave={() => setHoverCard(null)}
            onClick={() => props.onChange(processItem(value, key, multi))}
          >
            <CheckMarkWrapper>
              <CheckMark isActive={isActive} />
            </CheckMarkWrapper>
            <Card
              isActive={isActive || isHover}
              className={`t-PlacementType_${key}`}
              format={key}
            />
            <ItemText>
              <ItemTitle>{t[key]}</ItemTitle>
              <ItemNote>{t[`${key}_note`]}</ItemNote>
            </ItemText>
          </Item>
        )
      })}
    </Wrapper>
  )
}

function leaveFirstOption(
  options: Array<PlacementType>,
  value: Array<PlacementType>
): Array<PlacementType> {
  return [_.find(options, (option) => _.includes(value, option)) || 'promo_post']
}

function processItem(
  value: Array<PlacementType>,
  item: PlacementType,
  multi: boolean
): Array<PlacementType> {
  if (!multi) return [item]
  if (value.length === 1 && value[0] === item) return [item]

  return _.includes(value, item) ? _.without(value, item) : _.sortBy([...value, item])
}
